import React from 'react';

import { useIntl } from 'react-intl';

import { Fab } from 'components/fab';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useOrderContext } from 'state/order';
import { routes } from 'utils/routing';

const MainFabButton = () => {
  const { formatMessage } = useIntl();
  const { isAuthenticated } = useAuthContext();
  const { numCartPreviewEntries } = useOrderContext();
  const enableMainFabButton = useFlag(LaunchDarklyFlag.ENABLE_MAIN_FAB_BUTTON);

  if (!enableMainFabButton) {
    return null;
  }

  let fabCaption = formatMessage({ id: 'homeMainFabSignInUp' });
  if (isAuthenticated() && numCartPreviewEntries < 1) {
    fabCaption = formatMessage({ id: 'startOrder' });
  } else if (isAuthenticated() && numCartPreviewEntries > 0) {
    fabCaption = formatMessage({ id: 'viewCart' });
  }

  return (
    <Fab
      caption={fabCaption}
      to={isAuthenticated() ? routes.menu : formatMessage({ id: 'routes.signUp' })}
    />
  );
};

export default MainFabButton;
